import { gql } from "@apollo/client";

const GET_CLUB_MEMBERS = gql`
  query clubMembers($filter: ListClubMembers!) {
    clubMembers(filter: $filter) {
      clubMembers {
        id
        club {
          id
          clubName
        }
        user {
          id
          name
          surname
        }
      }
    }
  }
`;

export default GET_CLUB_MEMBERS;
